import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { time } from 'app/constants';
import { HTTPService, DateService } from 'app/services';

import * as moment from 'moment';

@Component({
  selector: 'app-review-reminders',
  templateUrl: './review-reminders.component.html',
  styleUrls: ['./review-reminders.component.scss'],
})
export class ReviewRemindersComponent implements OnInit {
  @Input() id: string = '';
  @Input() index: any;
  @Input() reminder: any;
  @Input() currentDateTime: any = '';
  @Input() sameLine: boolean = true;
  @Input() isTimeOpen: boolean = false;
  @Input() dropDownPositionTop: boolean = false;
  @Input() showOrder: boolean = true;
  @Input() reviewSetting: boolean = false;

  @Output() deleteReminderItem = new EventEmitter<any>();

  selectedTime: any = {};
  selectedDay: any = {};
  timeOptions: any = time;
  dayOptions: any[] = [
    { label: '1 day', value: 1 },
    { label: '2 days', value: 2 },
    { label: '3 days', value: 3 },
  ];
  reminderDayText = {
    1: 'next day',
    2: 'the day after the next',
    3: 'three days from now',
  };
  visible = {
    datetime: false,
    message: false,
  };

  dropDownPosition: any = {
    position: 'bottom',
    setPositionDynamically: true,
  };

  constructor(private httpService: HTTPService, private dateService: DateService) {}

  async ngOnInit() {
    if (!this.currentDateTime) {
      this.currentDateTime = await this.httpService.getServerTime();
    }

    this.setDefaultDateTime();
  }

  setDefaultDateTime() {
    /*
      Adding a fix for ALP-14738
      Commenting out below two line the actual issue 
      was currentDateTime is an instance of date but below method 
      getCurrentDateTimeTz taking the time only not date which in retruns invalid date
      this.selectedTime = time.find(element =>element.value === '12:00');
      this.handleSelect('selectedTime', 'time',  this.selectedTime);
     */
    //Commenting out below line for Adding a fix for ALP-14738 - reason already mentioned above
    /** Getting current time according to the timezone */
    //const currentDateTimeTz = this.dateService.getCurrentDateTimeTz(this.currentDateTime);
    const currentDateTimeTz = (this.currentDateTime instanceof Date) ? this.dateService.getCurrentDateTimeTz(this.currentDateTime.getTime()) : this.dateService.getCurrentDateTimeTz(this.currentDateTime);
    const currentMinutes = this.dateService.getNearestSuccessorQuarterHour(moment(currentDateTimeTz).format('mm'));
    const currentHour = moment(currentDateTimeTz).add(Number(currentMinutes) === 0 ? 1 : 0, 'hour').format('HH');

    for (let i = 0; i < time.length; i++) {
      if (time[i].value === (this.reviewSetting ? `${this.reminder.time}` : `${currentHour}:${currentMinutes}`)) {
        this.selectedTime = time[i];
      }
    }

    for (let i = 0; i < this.dayOptions.length; i++) {
      const day = this.dayOptions[i];

      if (Number(day.value) === Number(this.reminder.day)) {
        this.selectedDay = day;
        break;
      }
    }
  }

  toggle(name: string) {
    this.visible.datetime = !!(name === 'message' && this.visible.message);

    this.visible[name] = !this.visible[name];
  }

  handleSelect(name: string, key: string, data: any) {
    this[name] = data;
    this.reminder[key] = data.value;
  }

  handleChange(name: string, value: string) {
    this.reminder[name] = value;
  }
}
